import { Component, OnInit, ViewRef, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { SubheaderHandlerService } from '../../services/subheader-handler.service';
@Component({
  selector: 'app-problem-solving-attitude',
  templateUrl: './problem-solving-attitude.component.html'
})
export class ProblemSolvingAttitudeComponent implements OnInit {
  isShowDraft: boolean;
  isShowAdvocating: boolean;
  isShowSupport: boolean;
  stageName: string;
  currentPageName: string;
  currentPageNameSubscription: Subscription;
  changeAttitude = true;
  constructor(private cdr: ChangeDetectorRef, private subHeaderService: SubheaderHandlerService) { }

  ngOnInit() {
    this.currentPageNameSubscription = this.subHeaderService.caseDetails$.subscribe(resp => {
      this.changeAttitude = !this.changeAttitude;
      this.stageName = resp.caseStatus;
      this.currentPageName = resp.pageName;
      this.updateProbSolvingClass();
    });
  }

  updateProbSolvingClass() {
    if (this.stageName === 'Won') {
      this.isShowSupport = true;
      this.isShowDraft = false;
      this.isShowAdvocating = false;
    } else if (this.stageName === 'Advocating' || this.stageName === 'Lost') {
      this.isShowAdvocating = true;
      this.isShowSupport = false;
      this.isShowDraft = false;
    } else if (this.stageName === 'Draft' || this.stageName === 'Pending' || this.stageName === 'Terminated'
      || this.currentPageName === 'SiteSelection') {
      this.isShowDraft = true;
      this.isShowSupport = false;
      this.isShowAdvocating = false;
    }
  }
  detectChangeReady() {
    if (!(this.cdr as ViewRef).destroyed) {
      this.cdr.detectChanges();
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/problem-solving-attitude/problem-solving-attitude.component.ts